module.exports = __webpack_public_path__ + "img/desc-1.2.ade65832.jpg";